<template>
  <div class="border-t px-4 py-4" v-if="!noAmounts">
    <div class="flex flex-col md:flex-row justify-end space-y-3 md:space-y-0 md:space-x-4">
      <sqr-input-amount
        :label="$t('invoice_deposit')"
        :value="invoice.deposit"
        @change="$emit('invoice-change', { field: 'deposit', value: $event })"
      />
      <sqr-input-amount
        v-if="!noAmounts && !noTaxes"
        :label="$t('invoice_total_eot')"
        :value="invoice.totalEot"
        is-static
        readonly
      />
      <sqr-input-amount
        v-if="!noAmounts && !noTaxes"
        label="invoice_total_vat"
        :value="invoice.totalVat"
        is-static
        readonly
      />
      <div>
        <sqr-input-amount
          v-if="!noAmounts"
          :label="$t('invoice_total_ti')"
          :value="invoice.totalTi"
          is-static
          readonly
        />
        <div class="hidden md:block text-xs text-gray-700 text-right" v-if="!noAmounts">
          {{ $t('invoice_rounding') }} {{ invoice.rounding | amount }}
        </div>
      </div>
      <sqr-input-amount
        v-if="!noAmounts"
        :label="$t('invoice_total_due')"
        :value="invoice.totalDue"
        is-static
        readonly
      />
    </div>
  </div>
</template>

<script>
import amount from '@/filters/amount';
import SqrInputAmount from '@/components/SqrInputAmount';

export default {
  name: 'InvoiceTotalsForm',
  components: { SqrInputAmount },
  filters: { amount },
  props: {
    invoice: {
      required: true,
      type: Object,
      default: () => ({})
    },
    noAmounts: Boolean,
    noTaxes: Boolean
  }
};
</script>
